import { useState, useEffect } from 'react';
import { Col, Row, Card, Form, Button } from 'react-bootstrap';
import { userStore } from 'store/UserStore';
import UserHttp from '../services/profile.service';
import DashboardHttp from '../services/profile.service';
import Loader from 'shared/common/loader';
import { toast } from 'react-toastify';

const CapitalGainReport = () => {
    const [selectedFinancialYear, setSelectedFinancialYear] = useState('');
    const [financialYears, setFinancialYears] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [customer] = userStore((state: any) => [state.customer]);
    // const [filterType, setFilterType] = useState("financialYear"); 

    const initialStateFilter = {
        pan: customer?.kyc?.pan?.value,
        fromDate: '',
        toDate: '',
    };

    const [filter, setFilter] = useState(initialStateFilter);

    useEffect(() => {
        getUserFinancialYear();
    }, []);

    const getUserFinancialYear = async () => {
        try {
            const res = await DashboardHttp.getCustomerCreatedYear();
            if (res?.data?.data) {
                const years = res?.data?.data?.map(
                    (item: { startYear: number; financialYear: string }) => `FY ${item.financialYear}`
                );
                setFinancialYears(years);
            }
        } catch (error) {
            console.error('Error fetching financial years:', error);
        }
    };

    const handleFinancialYearChange = (e: any) => {
        const selectedFY = e.target.value;
        setSelectedFinancialYear(selectedFY);

        if (selectedFY) {
            const startYear = parseInt(selectedFY.substring(3, 7));
            const fromDate = `${startYear}-04-01`;
            const toDate = `${startYear + 1}-03-31`;

            setFilter({ ...filter, fromDate, toDate });
        }
    };


    const generateReport = async () => {
        try {
            setLoading(true);
    
            if (!filter.fromDate || !filter.toDate) {
                setLoading(false);
                return toast.error("Please select a financial year");
            }
    
    
            const resp = await UserHttp.capitalGain(filter);
            setLoading(false);
    
            if (resp?.status === 200) {
                toast.success(resp?.data?.data?.msg);
                setFilter(initialStateFilter);
                setSelectedFinancialYear("");
    
                const reportLink = resp?.data?.data;
                console.log("Report Link:", reportLink);
    
                if (reportLink && typeof reportLink === "string" && reportLink.startsWith("http")) {
                    const newTab = window.open("", "_blank");
                    newTab.location.href = reportLink; 
                } else {
                    console.log("Invalid report link received");
                    // toast.error("Invalid report link received");
                }
            }
        } catch (err) {
            setLoading(false);
            toast.error("Something went wrong");
            console.error("Error generating report:", err);
        }
    };
    

    return (
        <>
            {loading && <Loader />}
            <Card>
                <Card.Body className="p-5">
                    <Card.Title>Capital Gains Statement</Card.Title>
                   

                    <Row className="mt-4 d-flex align-items-end">
                        <Col md={6}>
                            <Form.Group controlId="financialYear">
                                <Form.Label>Select Financial Year</Form.Label>
                                <Form.Select onChange={handleFinancialYearChange} value={selectedFinancialYear}>
                                    <option value="">Select Financial Year</option>
                                    {financialYears.map((fy, index) => (
                                        <option key={index} value={fy}>
                                            {fy}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={6} className="d-flex justify-content-start">
                            <Button className="btn w-100 w-md-auto" onClick={generateReport} disabled={!selectedFinancialYear}>
                                Generate Report
                            </Button>
                        </Col>
                    </Row>



                </Card.Body>
            </Card>
        </>
    );
};

export default CapitalGainReport;
